import "./projects.css";

function TsengLab() {
  return (
    <div className="project-container">
      {/* Hero Banner */}
      <div className="banner">
        <img
          src="/assets/projects/tsenglab2.png"
          alt="Tseng Lab Database"
          className="banner-image"
        />
      </div>

      {/* Project Header */}
      <div className="project-header">
        <h1 className="project-title">Tseng Lab Database</h1>
        <p className="project-subtitle">
          An independent project building a database query system with an intuitive UI and complex data visualizations for gene and single-cell RNA sequencing data.
        </p>
        <div className="badge-container">
          <span className="badge">Data Visualization</span>
          <span className="badge">Python</span>
          <span className="badge">SQL</span>
          <span className="badge">UI Design</span>
        </div>
      </div>

      {/* Overview Section - 3 Columns */}
      <div className="project-overview">
        <div className="overview-3col">
          <div className="overview-col-item">
            <div className="overview-icon">🧬</div>
            <h3 className="overview-title">My Role</h3>
            <p className="overview-text">
              Independent developer and designer. I built the database query system, created data visualizations, and designed the UI from scratch.
            </p>
          </div>

          <div className="overview-col-item">
            <div className="overview-icon">⏱️</div>
            <h3 className="overview-title">Timeline</h3>
            <p className="overview-text">
              Iterative development process exploring Excel, SQL, Tableau, and ultimately Python to find the best solution for complex data visualization needs.
            </p>
          </div>

          <div className="overview-col-item">
            <div className="overview-icon">✨</div>
            <h3 className="overview-title">Key Contributions</h3>
            <ul className="overview-list">
              <li>Database query system with intuitive UI</li>
              <li>Complex visualizations for gene and RNA sequencing data</li>
              <li>Multi-dimensional analysis tools</li>
              <li>Stakeholder collaboration and iteration</li>
            </ul>
          </div>
        </div>
      </div>

      {/* Design Challenge Section */}
      <div className="case-study-section">
        <h2 className="section-title">The Challenge</h2>
        <div className="case-study-content">
          <p className="case-study-text">
            The Tseng Lab needed a way to query and visualize complex gene and single-cell RNA sequencing data. Working with stakeholders of non-technical backgrounds, I needed to translate their research needs into <strong className="highlight">actionable data visualizations</strong> that made patterns and insights easily accessible.
          </p>
          <p className="case-study-text">
            After exploring multiple tools, Excel, SQL, Tableau, I ultimately chose Python for its flexibility in handling <strong className="highlight">multi-dimensional analysis</strong> and creating custom visualizations that could adapt to the lab's evolving research questions.
          </p>
          <div className="brand-values">
            <h3 className="brand-values-title">What I Focused On</h3>
            <div className="values-grid">
              <div className="value-item">
                <span className="value-icon">📊</span>
                <div className="value-content">
                  <strong>Complex Visualizations</strong>
                  <span className="value-text">Built multi-dimensional visualizations for gene and RNA sequencing data that reveal patterns and insights.</span>
                </div>
              </div>
              <div className="value-item">
                <span className="value-icon">🔍</span>
                <div className="value-content">
                  <strong>Intuitive Query System</strong>
                  <span className="value-text">Designed a database query interface that makes complex data accessible to non-technical users.</span>
                </div>
              </div>
              <div className="value-item">
                <span className="value-icon">🤝</span>
                <div className="value-content">
                  <strong>Stakeholder Collaboration</strong>
                  <span className="value-text">Collaborated closely with researchers through multiple iterations and feedback loops to refine the system.</span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Private project notice */}
      <div className="case-study-section">
        <div className="case-study-content">
          <div className="prototype-cta">
            This project is private. <a href="mailto:ma.ra@northeastern.edu" className="link-style">Email</a> for a walkthrough or access.
          </div>
        </div>
      </div>
    </div>
  );
}

export default TsengLab;
